/* ── Hoke Studios Coming Soon — hoke.js ── */

var KLAVIYO_PUBLIC_KEY = 'TUe2dH';
var KLAVIYO_LIST_ID = ''; // Leave blank — Klaviyo will match by email to existing profiles

document.addEventListener('DOMContentLoaded', function () {

  var hokeForm = document.getElementById('hokeForm');
  var hokeSuccess = document.getElementById('hokeSuccess');

  if (!hokeForm || !hokeSuccess) return;

  // Bot protection: record page load time
  var hokeLoadTime = Date.now();
  var tsField = document.getElementById('hokeFormTimestamp');
  if (tsField) tsField.value = hokeLoadTime;

  // Shopify redirects back with #hokeForm after successful submission
  if (window.location.hash === '#hokeForm') {
    hokeForm.style.display = 'none';
    hokeSuccess.classList.add('visible');
    hokeSuccess.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (typeof gtag === 'function') {
      gtag('event', 'conversion', { send_to: 'AW-18068209052/i_sICL2V-pYcEJz7y6dD', value: 1.0, currency: 'USD' });
    }
    return;
  }

  // Client-side validation before submit
  hokeForm.addEventListener('submit', function (e) {

    // Bot protection: reject if honeypot is filled
    var honeypot = document.getElementById('hokeHoneypot');
    if (honeypot && honeypot.value.trim() !== '') {
      e.preventDefault();
      return;
    }

    // Bot protection: reject if submitted in under 2 seconds
    if (Date.now() - hokeLoadTime < 2000) {
      e.preventDefault();
      return;
    }

    var fields = ['hokeFirstName', 'hokeLastName', 'hokeEmail', 'hokeState'];
    var valid = true;

    fields.forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || !el.value.trim()) {
        if (el) el.style.borderColor = 'rgba(171,49,54,0.7)';
        valid = false;
      }
    });

    if (!valid) {
      e.preventDefault();
      return;
    }

    // Grab form values before Shopify navigates away
    var firstName = document.getElementById('hokeFirstName').value.trim();
    var lastName  = document.getElementById('hokeLastName').value.trim();
    var email     = document.getElementById('hokeEmail').value.trim();
    var state     = document.getElementById('hokeState').value.trim();

    // Fire Klaviyo profile update in the background
    // This runs alongside the normal Shopify form POST
    sendToKlaviyo(firstName, lastName, email, state);

    var btn = hokeForm.querySelector('.hoke-btn');
    if (btn) {
      btn.textContent = 'Submitting...';
      btn.disabled = true;
    }

    // Let the form continue its normal Shopify POST
  });

  // Clear error highlight on input
  ['hokeFirstName', 'hokeLastName', 'hokeEmail', 'hokeState'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) {
      el.addEventListener('input', function () {
        this.style.borderColor = '';
      });
    }
  });

});

// ── Cart Page ──
(function () {

  var itemsEl = document.getElementById('hokeCartPageItems');
  if (!itemsEl) return;

  itemsEl.addEventListener('click', function (e) {
    var qtyBtn    = e.target.closest('.hoke-qty-btn');
    var removeBtn = e.target.closest('.hoke-cart-remove');

    if (qtyBtn) {
      var key    = qtyBtn.dataset.key;
      var qty    = parseInt(qtyBtn.dataset.qty, 10);
      var newQty = qtyBtn.dataset.action === 'increase' ? qty + 1 : qty - 1;
      updateCartItem(key, Math.max(0, newQty));
    }

    if (removeBtn) {
      updateCartItem(removeBtn.dataset.key, 0);
    }
  });

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (cart.item_count === 0) {
        location.reload();
        return;
      }
      // Update subtotal
      document.getElementById('hokeCartPageSubtotal').textContent = formatMoney(cart.total_price);
      // Update changed item row
      var item = cart.items.find(function (i) { return i.key === key; });
      var row  = itemsEl.querySelector('[data-key="' + key + '"]');
      if (!row) { location.reload(); return; }
      if (!item || item.quantity === 0) {
        row.remove();
      } else {
        row.querySelector('.hoke-qty-value').textContent = item.quantity;
        row.querySelectorAll('.hoke-qty-btn').forEach(function (btn) {
          btn.dataset.qty = item.quantity;
        });
        row.querySelector('.hoke-cart-page-item-line-price').textContent = formatMoney(item.line_price);
      }
    })
    .catch(function () { location.reload(); });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

})();

// ── Cart Drawer ──
(function () {

  var form = document.getElementById('hokeProductForm');
  if (!form) return;

  var overlay    = document.getElementById('hokeCartOverlay');
  var drawer     = document.getElementById('hokeCartDrawer');
  var closeBtn   = document.getElementById('hokeCartClose');
  var continueBtn = document.getElementById('hokeCartContinue');

  // Variant switching — update hidden ID when option selects change
  var product = window.hokeProduct;
  if (product && product.variants && product.variants.length > 1) {
    var selects = form.querySelectorAll('select[name^="options"]');
    selects.forEach(function (sel) {
      sel.addEventListener('change', updateVariant);
    });
    function updateVariant() {
      var chosen = Array.from(selects).map(function (s) { return s.value; });
      var match = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (match) {
        form.querySelector('input[name="id"]').value = match.id;
        if (match.featured_image) {
          var src = match.featured_image.src.split('?')[0] + '?width=800';
          var mainImg = document.getElementById('hokeMainImage');
          if (mainImg) mainImg.src = src;
        }
      }
    }
  }

  function openDrawer() {
    overlay.classList.add('active');
    drawer.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    overlay.classList.remove('active');
    drawer.classList.remove('active');
    document.body.style.overflow = '';
  }

  overlay.addEventListener('click', closeDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  continueBtn.addEventListener('click', closeDrawer);

  drawer.addEventListener('click', function (e) {
    var qtyBtn    = e.target.closest('.hoke-qty-btn');
    var removeBtn = e.target.closest('.hoke-cart-remove');

    if (qtyBtn) {
      var key    = qtyBtn.dataset.key;
      var qty    = parseInt(qtyBtn.dataset.qty, 10);
      var newQty = qtyBtn.dataset.action === 'increase' ? qty + 1 : qty - 1;
      updateDrawerItem(key, Math.max(0, newQty));
    }
    if (removeBtn) {
      updateDrawerItem(removeBtn.dataset.key, 0);
    }
  });

  function renderDrawer(cart) {
    var html = '';
    cart.items.forEach(function (item) {
      html +=
        '<div class="hoke-cart-item" data-key="' + item.key + '">' +
          (item.image ? '<img src="' + item.image + '" alt="' + item.product_title + '" class="hoke-cart-item-image">' : '') +
          '<div class="hoke-cart-item-info">' +
            '<p class="hoke-cart-item-title">' + item.product_title + '</p>' +
            (item.variant_title && item.variant_title !== 'Default Title'
              ? '<p class="hoke-cart-item-variant">' + item.variant_title + '</p>' : '') +
            '<p class="hoke-cart-item-price">' + formatMoney(item.price) + '</p>' +
            '<div class="hoke-cart-item-actions">' +
              '<div class="hoke-qty-control">' +
                '<button class="hoke-qty-btn" data-action="decrease" data-key="' + item.key + '" data-qty="' + item.quantity + '">−</button>' +
                '<span class="hoke-qty-value">' + item.quantity + '</span>' +
                '<button class="hoke-qty-btn" data-action="increase" data-key="' + item.key + '" data-qty="' + item.quantity + '">+</button>' +
              '</div>' +
              '<button class="hoke-cart-remove" data-key="' + item.key + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    });
    document.getElementById('hokeCartItems').innerHTML = html;
    document.getElementById('hokeCartSubtotal').textContent = formatMoney(cart.total_price);
    updateCartCount(cart.item_count);
  }

  function updateDrawerItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (cart.item_count === 0) {
        closeDrawer();
        return;
      }
      renderDrawer(cart);
    })
    .catch(function () { closeDrawer(); });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var submitBtn = form.querySelector('[name="add"]');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Adding...';

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        renderDrawer(cart);
        openDrawer();
      })
      .catch(function () {
        form.submit(); // fall back to normal submit if AJAX fails
      })
      .finally(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Add to Cart';
      });
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCartCount(count) {
    var el = document.getElementById('hokeCartCount');
    if (!el) return;
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  }

})();

function sendToKlaviyo(firstName, lastName, email, state) {
  try {
    var payload = {
      data: {
        type: 'profile',
        attributes: {
          email: email,
          first_name: firstName,
          last_name: lastName,
          properties: {
            state: state,
            signup_source: 'Founders Edition Coming Soon'
          }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/profiles/?company_id=' + KLAVIYO_PUBLIC_KEY, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2023-12-15'
      },
      body: JSON.stringify(payload),
      keepalive: true // ensures the request completes even as the page navigates
    }).catch(function(err) {
      console.log('Klaviyo sync note:', err);
    });
  } catch(e) {
    console.log('Klaviyo sync note:', e);
  }
}